import type { CommonProps } from "@/@types/common";
import Loading from "@/components/shared/Loading";
import { Suspense } from "react";

const AdminAreaNonProtectedPageContainer = ({ children }: CommonProps) => {
  return (
    <Suspense
      fallback={
        <div className="flex flex-auto flex-col h-[100vh]">
          <Loading loading={true} />
        </div>
      }
    >
      <div className="flex flex-auto flex-col h-[100vh]">
        {children}
      </div>
    </Suspense>
  );
};

export default AdminAreaNonProtectedPageContainer;
